export default "__VITE_ASSET__C9$0ZIjy__"